import { MBC_BRIEF_FIELD_LABELS, type MbcBriefField } from "@nlc/shared-types";

export const BRIEF_FIELD_OPTIONS = Object.entries(MBC_BRIEF_FIELD_LABELS).map(
  ([id, label]) => ({ id: id as MbcBriefField, label }),
);
